(() => {
  const KLAVIYO = {
    companyId: 'QViP6m',
    listId: 'WKWXSm',
    revision: '2026-10-15',
    source: 'MONTKUSH footer signup',
  };

  class MontkushFooterHub {
    constructor(root) {
      this.root = root;
      this.details = [...root.querySelectorAll('.mk-footer-hub__menu')];
      this.signup = root.querySelector('#MontkushFooterSignup');
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      this.syncMenuState = this.syncMenuState.bind(this);
      this.syncMenuState();
      this.desktopQuery.addEventListener?.('change', this.syncMenuState);
      this.signup?.addEventListener('submit', (event) => this.submitToKlaviyo(event));
    }

    syncMenuState() {
      if (this.desktopQuery.matches) this.details.forEach((detail) => { detail.open = true; });
      else this.details.forEach((detail) => { detail.open = false; });
    }

    setMessage(message, state) {
      const result = this.signup?.querySelector('.mk-footer-hub__form-result');
      if (!result) return;
      result.textContent = message;
      result.dataset.state = state;
    }

    async submitToKlaviyo(event) {
      const form = event.currentTarget;
      const emailInput = form.querySelector('input[type="email"]');
      const button = form.querySelector('button[type="submit"]');
      const email = emailInput?.value.trim();
      if (!email || !emailInput.checkValidity()) return;
      event.preventDefault();
      button.disabled = true;
      button.querySelector('span').textContent = 'Joining…';
      this.setMessage('', '');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(KLAVIYO.companyId)}`, {
          method: 'POST',
          headers: { 'content-type': 'application/vnd.api+json', revision: KLAVIYO.revision },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: KLAVIYO.source,
                profile: { data: { type: 'profile', attributes: { email } } },
              },
              relationships: { list: { data: { type: 'list', id: KLAVIYO.listId } } },
            },
          }),
          signal: controller.signal,
        });
        if (response.status !== 202) throw new Error(`Klaviyo subscription response ${response.status}`);
        form.reset();
        form.dataset.klaviyoSubmitted = 'true';
        this.setMessage('You’re in—check your inbox for your 20% off welcome offer.', 'success');
      } catch (error) {
        this.setMessage('We couldn’t complete your signup just now. Please try again.', 'error');
      } finally {
        clearTimeout(timeout);
        button.disabled = false;
        button.querySelector('span').textContent = 'Get 20% off';
      }
    }
  }

  const initialize = () => document.querySelectorAll('.mk-footer-hub:not([data-mk-footer-initialized])').forEach((root) => {
    root.dataset.mkFooterInitialized = 'true';
    new MontkushFooterHub(root);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
